module.exports = __webpack_public_path__ + "static/img/fm.d3becf4c.svg";